import React from "react";

const tonen = {
  neutraal: { border: "var(--border-subtle)", background: "var(--wit)", lijn: "var(--ink-600)" },
  actie: { border: "var(--actie-rand)", background: "var(--actie-zacht)", lijn: "var(--actie)" },
  positief: { border: "var(--positief-rand)", background: "var(--positief-zacht)", lijn: "var(--positief)" },
  aandacht: { border: "var(--aandacht-rand)", background: "var(--aandacht-zacht)", lijn: "var(--aandacht)" },
  alarm: { border: "var(--alarm-rand)", background: "var(--alarm-zacht)", lijn: "var(--alarm)" },
};

function Verloop({ punten, kleur }) {
  if (!punten || punten.length < 2) return null;
  const b = 100, h = 28;
  const min = Math.min(...punten), max = Math.max(...punten);
  const bereik = max - min || 1;
  const pad = punten.map((p, i) => [(i / (punten.length - 1)) * b, h - ((p - min) / bereik) * (h - 4) - 2]);
  const lijn = pad.map(([x, y]) => x.toFixed(1) + "," + y.toFixed(1)).join(" ");
  const vlak = "0," + h + " " + lijn + " " + b + "," + h;
  const laatste = pad[pad.length - 1];
  return (
    <svg viewBox={"0 0 " + b + " " + h} preserveAspectRatio="none" width="100%" height={h} aria-hidden="true" style={{ display: "block" }}>
      <polygon points={vlak} fill={kleur} opacity="0.10" />
      <polyline points={lijn} fill="none" stroke={kleur} strokeWidth="1.5" strokeLinejoin="round" strokeLinecap="round" vectorEffect="non-scaling-stroke" />
      <circle cx={laatste[0]} cy={laatste[1]} r="2" fill={kleur} />
    </svg>
  );
}

export function MetricCard({ label, value, unit, note, tone = "neutraal", trend, href, onClick }) {
  const t = tonen[tone];
  const [hover, setHover] = React.useState(false);
  const klikbaar = !!(href || onClick);
  const Comp = href ? "a" : onClick ? "button" : "div";
  return (
    <Comp href={href} onClick={onClick}
      onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}
      style={{ display: "block", width: "100%", textAlign: "left", textDecoration: "none",
        cursor: klikbaar ? "pointer" : "default", border: "1px solid " + t.border,
        padding: "var(--ruimte-6)", borderRadius: "var(--radius-vlak)", background: t.background,
        boxShadow: klikbaar && hover ? "var(--elevation-raised)" : "var(--elevation-card)",
        transition: "box-shadow var(--duur-normaal) var(--ease-standaard)" }}>
      <div style={{ fontSize: "var(--fs-xs)", letterSpacing: "var(--ls-label)", textTransform: "uppercase",
        color: "var(--text-soft)", fontWeight: "var(--fw-medium)" }}>{label}</div>
      <div className="cijfer" style={{ marginTop: "var(--ruimte-4)", font: "var(--text-h1)", color: "var(--text-strong)", letterSpacing: "var(--ls-kop)" }}>
        {value}{unit ? <span style={{ fontSize: "var(--fs-h3)", color: "var(--text-soft)", marginLeft: 4 }}>{unit}</span> : null}
      </div>
      {trend ? <div style={{ marginTop: "var(--ruimte-5)" }}><Verloop punten={trend} kleur={t.lijn} /></div> : null}
      {note ? <div style={{ marginTop: "var(--ruimte-3)", fontSize: "var(--fs-sm)", color: "var(--text-soft)" }}>{note}</div> : null}
    </Comp>
  );
}
